import { useState } from "react"
import { EdamamEntry, FoodType } from "model/food/types"
import {
  updateNonIngredientEntryNutritionWhenPortionChange,
  updateEdamaNutritionWhenUnitChange,
  updateManualNutritionMealWhenPortionChange,
} from "features/food/helper/edamaForm"

const useEdamaForm = <T extends EdamamEntry>(edama: T) => {
  const [food, setFood] = useState<T>(edama)

  const onPortionChange = (portion: number) => {
    const nutrition =
      "isManualNutrition" in food && food.isManualNutrition
        ? updateManualNutritionMealWhenPortionChange(food, portion)
        : updateNonIngredientEntryNutritionWhenPortionChange(food, portion)

    setFood({
      ...food,
      ...nutrition,
      portion,
    })
  }

  const onUnitChange = (unit: string) => {
    const nutrition = updateEdamaNutritionWhenUnitChange(food, unit)
    setFood({ ...food, ...nutrition, unit })
  }

  const updateFoodAsManualNutrition = ({
    gram,
    ...nutrition
  }: Partial<FoodType>) => {
   
    if (food) {
      setFood({ ...food, ...nutrition, isManualNutrition: true })
    }
  }

  return {
    edama: food,
    setEdama: setFood,
    onPortionChange,
    onUnitChange,
    updateFoodAsManualNutrition,
  }
}

export default useEdamaForm
